module.exports = __webpack_public_path__ + "img/icon-smag-ar.d0723193.svg";